module.exports = __webpack_public_path__ + "img/157.4b32a658.png";